import { render } from "./Poem.vue?vue&type=template&id=489f7757&scoped=true"
import script from "./Poem.vue?vue&type=script&lang=js"
export * from "./Poem.vue?vue&type=script&lang=js"

import "./Poem.vue?vue&type=style&index=0&id=489f7757&scoped=true&lang=css"

import exportComponent from "C:\\PROJEKTE\\SLP_DE\\APP\\sjp_de\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489f7757"]])

export default __exports__